import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { catchError, finalize, of } from 'rxjs';
import { MultiplePropertyListingDto, PropertyListingDto, AdvertCreatorFiltersDto } from '../../../../../../app/services/property-matrixV2/models';
import { NotificationService } from '../../../../../../app/shared/services/notification-service/notification.service';
import { ReportKeyDialogComponent } from '../report-overview/report-key-dialog/report-key-dialog.component';
import { KeyValuePair } from '../../../../../../app/common/global-models/key-value-pair';
import { AdvertService } from '../../../../../services/property-matrixV2/services';
import { GlobalMethods } from '../../../../../../app/common/global-methods';
import { AdvertGenerateDevelopedComponent } from '../advert-generate-developed/advert-generate-developed.component';
import { AdvertGenerateDevelopableComponent } from '../advert-generate-developable/advert-generate-developable.component';

@Component({
  selector: 'app-advert-generate',
  templateUrl: './advert-generate.component.html',
  styleUrls: ['./advert-generate.component.scss', '../../../../../../css/2-modules/_admin-portal.scss']
})

export class AdvertGenerateComponent implements OnInit {

  @Input() selectedListing: PropertyListingDto = {};
  @Input() selectedListingGroup: MultiplePropertyListingDto = {};
  @Input() isMultiple: boolean = false;
  @Input() listingType: string = "";

  loading: boolean = false;
  reportItemTabNumber: number = 1;
  reportTypeTabNumber: number = 1;

  reportItems: KeyValuePair[] = [
    { key: 1, value: 'Advert for Developed' },
    { key: 2, value: 'Advert for Develop-able' },
    { key: 3, value: 'Advert Publish' },
  ];

  tabObject: any[] = [
    { id: 1, value: 'Advert for Developed', isDisabled: false },
    { id: 2, value: 'Advert for Develop-able', isDisabled: false },
    { id: 3, value: 'Advert Publish', isDisabled: false },
  ];

  developed: string = "developed";
  developable: string = "developable";
  doNotPublishPropertyUnderDevelopment: boolean = true;
  doNotPublishPropertyUnderDevelopable: boolean = true;
  advertCreatorFiltersDto: AdvertCreatorFiltersDto = {};

  @ViewChild(AdvertGenerateDevelopedComponent) advertGenerateDevelopedComponent?: AdvertGenerateDevelopedComponent;
  @ViewChild(AdvertGenerateDevelopableComponent) advertGenerateDevelopableComponent?: AdvertGenerateDevelopableComponent;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private advertService: AdvertService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.listingType = params['listingType'];
    });
    this.getAdvertFilterDataForListing();
  }

  private goToListingOverview(): void {
    this.router.navigate(['admin/listings/listing-overview'], {
      queryParams: {
        listingType: this.listingType
      }
    });
  }

  private setFirstAvailableTab() {
    if (this.tabObject[0]?.isDisabled) {
      this.reportItemTabNumber = 2;
    } else {
      this.reportItemTabNumber = 1;
    }
  }

  public navigateToReportItemTab(index: number): void {
    let indexToSelect = index - 1;

    while (this.tabObject[indexToSelect]?.isDisabled) {
      indexToSelect++;
      if (indexToSelect >= this.tabObject.length) {
        break;
      }
    }

    this.reportItemTabNumber = indexToSelect + 1;
    GlobalMethods.scrollToTop();
  }

  public openReportKeyDialog1(): void {
    this.dialog.open(ReportKeyDialogComponent, {
      width: '30vw',
      height: '35vh'
    });
  }

  public saveAdvertEntirely1(): void {
    try {
      if (this.reportItemTabNumber === 1) {
        this.advertGenerateDevelopedComponent?.saveAdvertDevelopedData();
      } else if (this.reportItemTabNumber === 2) {
        this.advertGenerateDevelopableComponent?.saveAdvertDevelopedData();
      }
    }
    catch (ex) {
      this.notificationService.showErrorMessage('Error', 'Could not save advert generator because of errors.');
    }
  }

  private getAdvertFilterDataForListing(): void {
    this.loading = true;
    this.advertService.apiV1AdvertGetAdvertFilterDataByListingIdGet({ propertyListingId: this.selectedListing.id })
      .pipe(
        catchError((err) =>
          of(this.notificationService.showErrorMessage("Error", "Could not get the filtered advert data."))
        ),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((result: AdvertCreatorFiltersDto | void) => {
        if (result) {
          this.advertCreatorFiltersDto = result;
          if (this.advertCreatorFiltersDto.advertSector?.length == 1) {
            const disableTabs = new Set<number>();
            this.advertCreatorFiltersDto.advertSector.forEach(element => {
              if (element.description === 'Developed') {
                disableTabs.add(2);
              } else if (element.description === 'Developable') {
                disableTabs.add(1);
              } else if (element.description === 'Both') {

              }
              this.tabObject.forEach(tab => {
                if (disableTabs.has(tab.id)) {
                  tab.isDisabled = true;
                }
              });
            });
          }
          this.setFirstAvailableTab();
        }
      });
  }

  public goToPublishTab(): void {
    if (this.reportItemTabNumber === 1) {
      const sectors = this.advertCreatorFiltersDto?.advertSector;
      if (sectors?.length === 1 &&
        sectors[0].description?.trim().toLowerCase() === 'both') {
        this.reportItemTabNumber = 2;
      } else {
        this.reportItemTabNumber = 3;
      }
    }
    else if (this.reportItemTabNumber === 2) {
      this.reportItemTabNumber = 3;
    }
    GlobalMethods.scrollToTop();
  }

}
